import React, { useEffect, useState } from 'react';
import { Table, Container, Alert, Button, Spinner } from 'react-bootstrap';
import { ThreeDots } from 'react-loader-spinner';

const baseUrl = process.env.REACT_APP_API_URL;

export const Leads = () => {
    const auth = localStorage.getItem("auth");
    const authJsonObject = JSON.parse(auth);
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [interestLoading, setInterestLoading] = useState({}); // Track loading per lead

    useEffect(() => {
        const fetchLeads = async () => {
            try {
                const token = authJsonObject["token"];
                const response = await fetch(`${baseUrl}/leads`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const data = await response.json();

                if (response.ok && data.data) {
                    setLeads(data.data);
                } else {
                    setError('No leads found');
                }
            } catch (err) {
                setError('Failed to fetch leads');
            } finally {
                setLoading(false);
            }
        };

        fetchLeads();
    }, []);

    const handleInterestClick = async (customerEmail, index) => {
        setInterestLoading(prev => ({ ...prev, [index]: true })); // Set loading for this lead
        try {
            const token = authJsonObject["token"];
            const response = await fetch(`${baseUrl}/leads`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    email: customerEmail,
                    interested_in_lead: true,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to update lead');
            }

            // Update the specific lead's "interested_in_lead" status in the leads state
            setLeads((prevLeads) => {
                const updatedLeads = [...prevLeads];
                updatedLeads[index].interested_in_lead = true;
                return updatedLeads;
            });

        } catch (error) {
            console.error(error);
            alert('Failed to update interest in lead');
        } finally {
            setInterestLoading(prev => ({ ...prev, [index]: false })); // Stop loading for this lead
        }
    };

    if (loading) {
        return (
            <div className="leads-loader-container text-center">
                <ThreeDots color="#050505" height={80} width={80} />
            </div>
        );
    }

    if (error) {
        return (
            <Container className="leads-container mt-4">
                <Alert variant="danger">{error}</Alert>
            </Container>
        );
    }

    return (
        <Container className="leads-container mt-4">
            <h2 className="leads-heading text-center">Leads</h2>
            {leads.length > 0 ? (
                <Table className="leads-table" striped bordered hover responsive>
                    <thead className="leads-table-header">
                        <tr>
                            <th>City</th>
                            <th>State</th>
                            <th>Zipcode</th>
                            <th>Country</th>
                            <th>Interested In</th>
                            <th>Interested</th>
                        </tr>
                    </thead>
                    <tbody className="leads-table-body">
                        {leads.map((lead, index) => (
                            <tr key={index}>
                                <td>{lead.city}</td>
                                <td>{lead.state}</td>
                                <td>{lead.zipcode}</td>
                                <td>{lead.country}</td>
                                <td>
                                    <div className="scrollable">
                                        {Array.isArray(lead.Interested_in) ? lead.Interested_in.join(', ') : lead.Interested_in}
                                    </div>
                                </td>
                                <td>
                                    {lead.interested_in_lead ? (
                                        <Button variant="success" disabled>
                                            Interested
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="primary"
                                            onClick={() => handleInterestClick(lead.email, index)}
                                            disabled={interestLoading[index]} // Disable button when loading
                                        >
                                            {interestLoading[index] ? (
                                                <Spinner
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                'Click Here'
                                            )}
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <Alert variant="info">No leads available.</Alert>
            )}
        </Container>
    );
};
